module.exports = __webpack_public_path__ + "static/media/EBSCO_logo.68895a0a.svg";